import React from "react";
import ViewReverse from "./ViewReverse";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import dynamicfunction from "../utils/dynamicfunction";
import { Switch } from "@mui/material";

const CustomSwitch = ({ leftText, rightText, checked, onChange }) => {
  const { TextWeight, isArabic } = dynamicfunction();

  return (
    <ViewReverse className={"items-center gap-3"}>

      <Text text={leftText} size={fontSizes.h14} weight={TextWeight.light} />
      <Switch checked={checked} onChange={onChange} className={`${isArabic ? "rotate-180 drop-shadow-light-arabic" : "drop-shadow-light"}`} />
      <Text text={rightText} size={fontSizes.h14} weight={TextWeight.light} />
      
    </ViewReverse>
  );
};

export default CustomSwitch;
